import _ from "lodash";
import React, { Fragment } from "react";

import classNames from "classnames";
import { connect } from "react-redux";
import { ProductFruits } from "react-product-fruits";
import { graphql, compose } from "lib/apolloClient";
import { Badge, Tooltip, KeyboardShortcutsProvider } from "@toddle-edu/ds-web";
import { ChevronLeftOutlined } from "@toddle-edu/ds-icons";
import withLoader from "UIComponents/GqlWithLoader";
import I18nHOC from "UIComponents/I18nHOC";
import { withPrivateScreen } from "UIComponents/PrivacyAware";
import UIModal from "UIComponents/UIModal";
import withPusherBind from "UIComponents/PusherConsumerHoc";
import AIUsageLimit from "UIComponents/AIUsageLimit";
import GlobalToastWrapper from "UIComponents/GlobalToastWrapper";
import {
  updateBasicUserDetails,
  goToRelativeRoute,
  openLinkInNewTab,
  addFeaturesWithKeyboardShortcuts,
  removeFeaturesWithKeyboardShortcuts,
  setActiveFeatureWithKeyboardShortcuts,
  setIsAIUsageLimitModalOpen,
} from "modules/Services";
import { handleGlobalKeyboardEvents } from "modules/GlobalKeyboardThunks";
import Bifurcation from "AppComponents/Bifurcation";
import GlobalSearchBar from "AppComponents/GlobalSearchBar";
import GlobalSearchBarV2 from "AppComponents/GlobalSearchBarV2";
import JumpToModal from "AppComponents/JumpToModal";
import { USER_TYPE_ENTITY_MAPPING } from "Constants";
import { updateNavigationObject } from "modules/NavigationModule";
import classes from "./ChildrenPage.scss";
import {
  setUserInfo,
  getUserInfo,
  setBifurcationModalStatus,
  setIsLastChildRemoved,
  getOrgWorkSpaceDetails,
  setGlobalTrayRetracted,
  setSelectedGlobalTrayIcon,
  logUserActivity,
  setToastMsg,
  setSentralPortalDetails,
} from "Login/modules/LoginModule";
import { updateUserCourses } from "Course/modules/CourseModule";
import {
  getGlobalConstantsQuery,
  getPlatformStaffIdentityDetailsQuery,
  getOrganizationGlobalConstantsQuery,
  getOrganizationConstantsQuery,
} from "modules/CommonQuery";
import {
  getUserBasicDetailsFromCache,
  getPlatformStaffIdentityDetailsFromCache,
} from "modules/CommonGraphqlHelpers";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import moment from "moment";
import ACLStore from "lib/aclStore";
import {
  UserCurriculumProgramsContext,
  getCurriculumProgramFreeStatus,
} from "Platform/modules/PlatformModule";
import { recordTrait, recordEvent } from "lib/eventTracker";
import ClassSelectionModal from "Courses/components/components/ClassSelectionModal";
import EventModal from "MyCalendar/components/EventModal";
import ProductUpdatesModal from "ProductUpdates/components/ProductUpdatesModal";
import {
  skipPreloadConfigurationsQuery,
  generateConfigurationQueryVariablesMemoized,
} from "ChildrenPage/modules/ChildrenPageUtils";
import {
  getUserAcadYearConstantsMemoize,
  getPageTitle,
  getSortedCurriculumsMemoize,
  getCurriculumProgramOrderByIdMemoize,
  getStaffUserDetailsMemoize,
  isParentUserMenuRoutes,
  getModalCountOnMount,
  getShortcutValidityStatus,
  getShortcutPreferenceValues,
} from "./Utils";
import {
  CURRICULUM_TYPE_PYP,
  CLOSE_SENTRAL_PORTAL_IFRAME,
} from "Constants/stringConstants";
import {
  getConfigurationQueryEnhancer,
  getPreferenceQueryEnhancer,
} from "ChildrenPage/modules/ChildrenPageEnhancers";
import { getUserProjectGroupsQuery } from "Projects/modules/ProjectQueries";
import { getUserProjectGroupsFromCache } from "Projects/modules/ProjectGraphqlHelpers";
import {
  getIsStaff,
  getSelectedAcademicYearId,
  getCurrentAcademicYear,
} from "modules/CommonSelectors";
import DowntimeAlert from "./components/DowntimeAlert";
// import NpsSurvey from "./components/NpsSurvey/NpsSurvey";
import {
  getStudentsCurriculumQuery,
  getStaffAcademicYearCurriculumMapQuery,
  getPlatformUserDetailsQuery,
  getCourseAcademicYearsQuery,
  getOrganizationDetailsQuery,
} from "./modules/ChildrenPageQuery";
import { getStudentsCurriculumFromCache } from "./modules/ChildrenPageGraphqlHelpers";
import { getShowSprinklrChat, isUserTypeParent } from "Utils";
import StudentBlockScreen from "StudentBlockScreen";
import { trackUserVisit } from "ToddleAnalytics/modules/ToddleAnalyticsModule";
import {
  getFormattedUserName,
  getUserIdentifierName,
} from "Utils/GetFormattedUserName";
import {
  getIsUserLoginActivityLogged,
  setIsUserLoginActivityLogged,
} from "services/localStorage";
import MessagingV2MediaViewer from "Platform/routes/MessagingV2/components/MessagingV2MediaViewer";

import {
  LIST_AND_ACCESS_ALL_PROGRAMMES_HOMEPAGE_PERMISSION,
  ENABLE_ACTIVITY_LOGGING,
  ENABLE_BEHAVIOUR_MODULE_PERM,
  ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
} from "Constants/permissionConstants";
import AIModuleMarketingModal from "./components/AIModuleMarketingModal";
import GlobalMenuTray from "../GlobalMenuTray";
import SupportDropdown from "../SupportDropdown";
import ShortcutToast from "../ShortcutToast";
import ShortcutManager from "../ShortcutManager";
import SentralPortalModal from "../SentralPortalModal";
import SentralPortalModalCloseToast from "../SentralPortalModalCloseToast";
import SamlIdpResponseScreen from "../SamlIdpResponseScreen";
import { isMarketingModalEnabled } from "Platform/modules/PlatformUtils";
import { getBehaviourNomenclatureFiltersMemoized } from "BehaviourConfiguration/modules/Utils";
import withControlParameters from "lib/aclService/hoc/withControlParameters";
import ACLStorage from "lib/aclService";
import { isProductUpdateV2Enabled } from "Teacher/routes/Courses/modules/utils";
import ProductUpdatesV2Modal from "ProductUpdatesV2/components/ProductUpdatesV2Modal";
import EventDetails from "MyCalendar/components/EventDetails";
import UpcomingMeetingNotification from "./components/UpcomingMeetingNotification/UpcomingMeetingNotification";
import { isMeetingToastNotificationEnabled } from "MyCalendar/components/EventModalV2/modules/Utils";

import withDerivedProps from "lib/withDerivedProps";
import { productFruitsWorkspaceCode } from "config";
import { getSelectedLearningCourse } from "LearningCourse/modules/Utils";
import { isOverviewContext } from "../SentralPortalModal/SentralPortalUtils";
import InternalToolsModal from "AppComponents/InternalToolsModal/InternalToolsModal";
import { getSettingValue } from "Utils/ConfigurationUtils";
import { WithConfigurationsAndPreferences } from "Utils/ConfigurationUtils/hoc";
import { generateConfigurationQueryVariablesV2 } from "Utils/ConfigurationUtils/Utils";

const TEACHER_TABS = [
  "teacher",
  "admin",
  "visitor",
  "accountSettingsTab",
  "schoolSettingsTab",
  "MY_HOME",
];
const EMPTY_ARRAY = [];

const getNonStaffUserDetails = data => {
  const {
    organizationAcademicYears,
    academicYearCurriculumProgramsMapping,
    selectedAcademicYear,
    organizationCurriculumPrograms,
    userCurriculumProgramsForAcademicYear = [],
    canListAndAccessAllPrograms,
    organizationId,
  } = data;

  /*
    // get academic year id from local storage (on first load, it won't be there)
    const storageAcademicYearId = manageAcademicYear.getFromLocalStorage();
    const selectedAcademicYearId = storageAcademicYearId
      ? storageAcademicYearId
      : currentAcademicYearId;
    */

  // find current academic year from organizationAcademicYears
  const currentAcademicYear = _.find(organizationAcademicYears, {
    isCurrentAcademicYear: true,
  });
  const currentAcademicYearId = _.get(currentAcademicYear, "id");
  const selectedAcademicYearId = _.get(selectedAcademicYear, "id", null);

  // get userCurriculumPrograms based on current selected academic year
  const userCurriculumProgramsFromCourses = _.get(
    academicYearCurriculumProgramsMapping,
    [
      selectedAcademicYearId ? selectedAcademicYearId : currentAcademicYearId,
      "curriculumPrograms",
    ],
    // this is done to avoid rerender due to reference change
    EMPTY_ARRAY
  );

  let updatedUserCurriculumPrograms = userCurriculumProgramsFromCourses;

  if (canListAndAccessAllPrograms) {
    updatedUserCurriculumPrograms = organizationCurriculumPrograms;
  }

  const curriculumProgramOrderById = getCurriculumProgramOrderByIdMemoize({
    curriculumPrograms: organizationCurriculumPrograms ?? [],
  });

  const sortedCurriculumsBasedOnCoursesAndProjectGroups = getSortedCurriculumsMemoize(
    {
      curriculumPrograms: updatedUserCurriculumPrograms,
      curriculumProgramOrderById,
    }
  );

  const sortedCurriculumsBasedOnUserAcademicYear = getSortedCurriculumsMemoize({
    curriculumPrograms: userCurriculumProgramsForAcademicYear,
    curriculumProgramOrderById,
  });

  let userCurriculumPrograms = _.unionBy(
    sortedCurriculumsBasedOnUserAcademicYear,
    sortedCurriculumsBasedOnCoursesAndProjectGroups,
    "id"
  );

  userCurriculumPrograms = getSortedCurriculumsMemoize({
    curriculumPrograms: userCurriculumPrograms,
    curriculumProgramOrderById,
  });

  return {
    userCurriculumPrograms,
    // selectedAcademicYearId,
    currentAcademicYearId,
  };
};
const getNonStaffUserDetailsMemoize = _.memoize(
  getNonStaffUserDetails,
  params => {
    return JSON.stringify({
      userId: params?.userId,
      organizationAcademicYearsIds: params?.organizationAcademicYearsIds,
      organizationCurriculumProgramsIdAndLabels:
        params?.organizationCurriculumProgramsIdAndLabels,
      userCurriculumProgramsForAcademicYearIdAndLabels:
        params?.userCurriculumProgramsForAcademicYearIdAndLabels,
      selectedAcademicYearId: params?.selectedAcademicYear?.id,
      canListAndAccessAllPrograms: params?.canListAndAccessAllPrograms,
      organizationId: params?.organizationId,
    });
  }
);

class ChildrenPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.eventModalRef = React.createRef();
  }

  onFocus = () => {
    trackUserVisit();
  };

  getIsGlobalSearchJumpToV2Enabled = () => {
    return ACLStore.can("FeatureFlag:EnableGlobalSearchJumpToV2");
  };

  globalKeyboardHandler = e => {
    const {
      handleGlobalKeyboardEvents,
      routeCourseId,
      areShortcutsEnabled,
    } = this.props;

    if (areShortcutsEnabled) {
      handleGlobalKeyboardEvents(e, routeCourseId);
    }
  };

  handleCloseIframe = event => {
    if (event.data?.type === CLOSE_SENTRAL_PORTAL_IFRAME) {
      this.props.setSentralPortalDetails({ isVisible: false, url: "" });
      this.props.setToastMsg(event.data.message);
    }
  };

  componentDidMount = () => {
    const {
      staffData = {},
      updateBasicUserDetails,
      userLoggedIn,
      addFeaturesWithKeyboardShortcuts,
      user_type,
      isLoading,
      goToRelativeRoute,
    } = this.props;

    const { firstLoggedInAt } = staffData;

    document.addEventListener("keydown", this.globalKeyboardHandler, false);

    if (user_type === "staff") {
      addFeaturesWithKeyboardShortcuts(["GO_TO_HOME"]);

      if (this.getIsGlobalSearchJumpToV2Enabled()) {
        addFeaturesWithKeyboardShortcuts(["JUMP_TO_FEATURE"]);
      }
    }

    if (
      !getIsUserLoginActivityLogged() &&
      ACLStore.can(ENABLE_ACTIVITY_LOGGING)
    ) {
      this.logUserLoginActivity();
    }

    this.updateUserDetails({
      shouldSaveInLocalStorage: true,
      shouldSaveInRedux: true,
    });
    if (userLoggedIn && !firstLoggedInAt) {
      setTimeout(() => {
        recordTrait({
          data: {
            first_logged_in_at: moment().toISOString(),
          },
        });
        updateBasicUserDetails({
          firstLoggedInAt: moment().toISOString(),
        });
      }, 1000);
    }
    if (userLoggedIn) {
      setTimeout(() => {
        updateBasicUserDetails({
          lastActiveAt: moment().toISOString(),
          portalType: "PLANNER",
        });
      }, 1000);
    }

    const isImpersonated = _.get(staffData, "isImpersonated", false);
    const preImpersonationPath = localStorage.getItem("preImpersonationPath");

    if (!isLoading && !isImpersonated && preImpersonationPath) {
      goToRelativeRoute({
        route: preImpersonationPath,
        type: "replace",
      });

      localStorage.removeItem("preImpersonationPath");
    }

    trackUserVisit();
    window.addEventListener("focus", this.onFocus);
    window.addEventListener("message", this.handleCloseIframe);
  };

  updateUserDetails = ({
    shouldSaveInLocalStorage = false,
    shouldSaveInRedux = false,
  } = {}) => {
    const {
      setUserInfo,
      staffData,
      i18n,
      organizationData,
      projects,
      userLoggedIn,
      organizationAcademicYears,
      academicYearCurriculumProgramsMapping,
      selectedAcademicYear,
      projectGroups,
      organizationCurriculumPrograms,
      userCurriculumProgramsForAcademicYear = [],
      staffIdentityDetails = {},
      userCurriculumPrograms,
      idpCode,
    } = this.props;

    if (!userLoggedIn) {
      return;
    }

    const locale =
      getSettingValue({ name: "locale", readFromUserAndOrgLevel: true }) ||
      "en";

    //Do not change this line
    i18n.changeLanguage(locale);

    setUserInfo({
      staffDetails: {
        ...staffData,
        userIdentityDetails: staffIdentityDetails.userIdentityDetails,
      },
      organization: {
        ...organizationData,
        ...projects,
      },
      portalType: "PLANNER",
      shouldSaveInLocalStorage,
      userCurriculumPrograms,
      shouldSaveInRedux,
      projectGroups,
      idpCode,
    });
  };

  componentDidUpdate = prevProps => {
    const {
      pageTitleInfo,
      t,
      curriculumTypeName,
      courseId,
      academicYearId,
      user_type,
      featuresWithKeyboardShortcuts,
      addFeaturesWithKeyboardShortcuts,
      removeFeaturesWithKeyboardShortcuts,
      userCurriculumPrograms,
      learningCourseDetails,
      isResourceUnavailable,
    } = this.props;

    if (isResourceUnavailable && !this.eventModalRef?.current) {
      this.onCloseCalendarEventModal();
      this.eventModalRef.current = true;
      this.onCloseCalendarEventDetails();
    }

    if (user_type === "staff") {
      const isJumpToV2Enabled = this.getIsGlobalSearchJumpToV2Enabled();
      const hasJumpToFeature = _.includes(
        featuresWithKeyboardShortcuts,
        "JUMP_TO_FEATURE"
      );

      if (isJumpToV2Enabled && !hasJumpToFeature) {
        addFeaturesWithKeyboardShortcuts(["JUMP_TO_FEATURE"]);
      } else if (!isJumpToV2Enabled && hasJumpToFeature) {
        removeFeaturesWithKeyboardShortcuts(["JUMP_TO_FEATURE"]);
      }
    }

    const courseDetails = getCourseDetailsFromCache({
      id: courseId,
      courseGradeFilters: { academicYearId },
    });

    if (
      (!_.includes(TEACHER_TABS, prevProps.activeTab) ||
        !_.isEqual(prevProps.projects, this.props.projects) ||
        !_.isEqual(prevProps.projectGroups, this.props.projectGroups) ||
        !_.isEqual(
          prevProps.staffIdentityDetails,
          this.props.staffIdentityDetails
        ) ||
        /**
         * When user curriculum programs are updated, save the user details in redux and local.
         */
        prevProps.userCurriculumPrograms !== userCurriculumPrograms) &&
      _.includes(TEACHER_TABS, this.props.activeTab)
    ) {
      this.updateUserDetails({
        shouldSaveInLocalStorage: true,
        shouldSaveInRedux: true,
      });
    }
    if (!_.isEqual(prevProps?.pageTitle, pageTitleInfo?.label)) {
      document.title = getPageTitle({
        pageTitleInfo,
        courseDetails: _.isEmpty(courseDetails)
          ? pageTitleInfo?.courseDetails
          : courseDetails,
        curriculumTypeName,
        learningCourseDetails,
        t,
      });
    }

    /** __FamilyPortal__
     *  1. "isLastChildRemoved" will be true when last remaining child is removed from settings page in Family Portal (Refer: ParentSettings.js)
     *  2. make "isLastChildRemoved" false in componentDidUpdate
     */
    const { isLastChildRemoved, setIsLastChildRemoved } = this.props;
    if (isLastChildRemoved) {
      setIsLastChildRemoved(false);
    }

    const { goToRelativeRoute } = this.props;
    if (!this.props.children) {
      goToRelativeRoute({ route: "platform", type: "replace" });
    }
  };

  logUserLoginActivity = async () => {
    const { logUserActivity } = this.props;
    setIsUserLoginActivityLogged(true);
    await logUserActivity({
      input: {
        operation: "UPDATE",
        module: "module_authentication",
        activityType: "LOGGED_IN",
        description: "logged in",
      },
    });
  };

  classSelectionDoneListener = async ({ addedCourses, removedCourses }) => {
    const {
      updateUserCourses,
      updateBasicUserDetails,
      setBifurcationModalStatus,
      portalType,
    } = this.props;

    await updateUserCourses({ addedCourses, removedCourses, portalType });
    await updateBasicUserDetails({
      showClassSelectionScreen: false,
      portalType,
    });
    setBifurcationModalStatus(true);
  };

  onCloseCalendarEventModal = () => {
    const { updateNavigationObject } = this.props;
    updateNavigationObject({
      calendarEventModal: null,
    });
  };

  onCloseCalendarEventDetails = () => {
    const { updateNavigationObject } = this.props;
    updateNavigationObject({
      calendarEventDetails: null,
    });
  };

  componentWillUnmount = () => {
    const { removeFeaturesWithKeyboardShortcuts, user_type } = this.props;
    if (user_type === "staff") {
      removeFeaturesWithKeyboardShortcuts(["GO_TO_HOME"]);

      if (this.getIsGlobalSearchJumpToV2Enabled()) {
        removeFeaturesWithKeyboardShortcuts(["JUMP_TO_FEATURE"]);
      }
    }

    document.removeEventListener("keydown", this.globalKeyboardHandler, false);
    window.removeEventListener("focus", this.onFocus);
    window.removeEventListener("message", this.handleCloseIframe);
  };

  renderGlobalMenuTrayUI() {
    const {
      t,
      userLoggedIn,
      showSprinklrChat,
      isIntercomV2Enabled,
      totalUnreadTrayCount,
      isGlobalTrayRetracted,
      setGlobalTrayRetracted,
      setSelectedGlobalTrayIcon,
    } = this.props;

    const toggleTrayRetracted = () => {
      setGlobalTrayRetracted(!isGlobalTrayRetracted);
      if (!isGlobalTrayRetracted) {
        setSelectedGlobalTrayIcon("");
      }
    };

    const globalMenuTrayButtonRetractedContainer = classNames({
      [classes.globalMenuTrayButtonRetracted]: isGlobalTrayRetracted,
      [classes.globalMenuTrayButtonRetractedExpanded]: !isGlobalTrayRetracted,
    });

    return (
      <>
        <div className={globalMenuTrayButtonRetractedContainer}>
          <Tooltip
            tooltip={t("common:show_magic_tray")}
            placement="topRight"
            onClick={toggleTrayRetracted}
          >
            <div className={classes.iconWithBadge}>
              <div className={classes.iconContainerRetracted}>
                <ChevronLeftOutlined size="xx-small" variant={"subtle"} />
                {isGlobalTrayRetracted ? (
                  <Badge
                    variant={"notifications"}
                    size={"medium"}
                    value={totalUnreadTrayCount}
                    type={"numeric"}
                  ></Badge>
                ) : null}
              </div>
            </div>
          </Tooltip>
        </div>
        <div className={classes.globalMenuTrayButton}>
          <GlobalMenuTray
            userLoggedIn={userLoggedIn}
            isIntercomV2Enabled={isIntercomV2Enabled}
            showSprinklrChat={showSprinklrChat}
          />
        </div>
      </>
    );
  }

  closeJumpToFeature = triggerPoint => () => {
    const {
      isJumpToFeatureOpen,
      setActiveFeatureWithKeyboardShortcuts,
    } = this.props;

    if (isJumpToFeatureOpen) {
      recordEvent({
        eventName: "JUMP_TO",
        eventData: {
          event_type: "CLOSE",
          triggerPoint,
        },
      });
      setActiveFeatureWithKeyboardShortcuts(null);
    }
  };

  render() {
    const {
      isPYPFree,
      staffData,
      bifurcationModalStatus,
      showClassSelectionScreen,
      calendarEventModal,
      productUpdateModalId,
      userLoggedIn,
      userCurriculumPrograms,
      isChildBlocked,
      userType,
      showSearchBar,
      isJumpToFeatureOpen,
      isInternalToolModalOpen,
      showAIUsageLimitModal,
      setIsAIUsageLimitModalOpen,
      isGlobalTrayEnabled,
      isIntercomV2Enabled,
      showSprinklrChat,
      areShortcutsEnabled,
      areShortcutPromptsEnabled,
      currentCurriculumProgramPlan,
      currentLanguage,
      calendarEventDetails,
      isSentralModalVisible,
      samlInitiatedDetails,
    } = this.props;

    const {
      firstName = "",
      showBifurcationScreen = false,
      lastName = "",
      email = "",
      role = "",
      firstLoggedInAt = "",
    } = staffData || {};

    //BifurcationModal is shown only for free PYP curriculum program
    const showBifurcationModal =
      bifurcationModalStatus && showBifurcationScreen && isPYPFree;

    const isGlobalSearchJumpToRevampEnabled = ACLStore.can(
      "FeatureFlag:EnableGlobalSearchJumpToRevamp"
    );

    const showGlobalMenuTray =
      ACLStore.can("FeatureFlag:EnableGlobalMenuTray") && isGlobalTrayEnabled;

    const shouldActivateProductFruits = ACLStore.can(
      "FeatureFlag:ProductFruits"
    );

    const isSentralStudentProfile = isOverviewContext();

    // const isNpsSurveyEnabled = ACLStore.can("FeatureFlag:InternalNPS");

    return (
      <KeyboardShortcutsProvider
        areShortcutsEnabled={areShortcutsEnabled}
        areShortcutPromptsEnabled={areShortcutPromptsEnabled}
        setupValidationStateOnMount={getModalCountOnMount} //TODO: Can we have better name to suggest that it is used for shortcuts?
        getShortcutValidityStatus={getShortcutValidityStatus}
      >
        {showSearchBar ? (
          isGlobalSearchJumpToRevampEnabled ? (
            <GlobalSearchBarV2 />
          ) : (
            <GlobalSearchBar />
          )
        ) : null}
        {isJumpToFeatureOpen && this.getIsGlobalSearchJumpToV2Enabled() ? (
          <JumpToModal onClose={this.closeJumpToFeature} />
        ) : null}
        {isInternalToolModalOpen ? <InternalToolsModal /> : null}
        {showAIUsageLimitModal && (
          <AIUsageLimit
            setIsAIUsageLimitModalOpen={setIsAIUsageLimitModalOpen}
            showAIUsageLimitModal={showAIUsageLimitModal}
          />
        )}
        {/* Hide Intercom when sentral modal is visible */}
        {(isIntercomV2Enabled || showSprinklrChat) &&
        !showGlobalMenuTray &&
        !isSentralModalVisible ? (
          <div className={classes.intercomIcon}>
            <SupportDropdown userLoggedIn={userLoggedIn} />
          </div>
        ) : null}
        <GlobalToastWrapper />
        {isMeetingToastNotificationEnabled() ? (
          <UpcomingMeetingNotification
            userId={this.props.userId}
            userEntityType={this.props.userEntityType}
            userLoggedIn={userLoggedIn}
            academicYearId={this.props.academicYearId}
            setToastMsg={this.props.setToastMsg}
            openLinkInNewTab={this.props.openLinkInNewTab}
            childID={this.props.childID}
            pathname={_.get(this.props, "location.pathname", "")}
          />
        ) : null}
        {showGlobalMenuTray && !isSentralModalVisible
          ? this.renderGlobalMenuTrayUI()
          : null}
        <MessagingV2MediaViewer />
        <UserCurriculumProgramsContext.Provider value={userCurriculumPrograms}>
          {this.props.children && (
            <Fragment>
              {shouldActivateProductFruits ? (
                <ProductFruits
                  workspaceCode={productFruitsWorkspaceCode}
                  language={
                    _.includes(["en", "es"], currentLanguage)
                      ? currentLanguage
                      : "en"
                  }
                  user={{
                    username: email,
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    signUpAt: firstLoggedInAt,
                    role: role,
                    props: {
                      plan: currentCurriculumProgramPlan,
                    },
                  }}
                />
              ) : null}
              <DowntimeAlert />
              {/* REMOVING NPS SURVEY COMPONENT FOR NOW */}
              {/* {isNpsSurveyEnabled ? <NpsSurvey /> : null} */}

              {/* StudentBlockScreen will only render in family portal if the selected child is BLOCKED */}
              {isChildBlocked &&
              isUserTypeParent({ userType }) &&
              !isParentUserMenuRoutes() ? (
                <StudentBlockScreen
                  userCurriculumPrograms={userCurriculumPrograms}
                />
              ) : (
                React.cloneElement(this.props.children, {
                  userCurriculumPrograms: userCurriculumPrograms,
                  userLoggedIn,
                  courseAcademicYears: this.props.courseAcademicYears,
                })
              )}
            </Fragment>
          )}
        </UserCurriculumProgramsContext.Provider>
        {productUpdateModalId ? (
          isProductUpdateV2Enabled() ? (
            <ProductUpdatesV2Modal
              userCurriculumPrograms={userCurriculumPrograms}
            />
          ) : (
            <ProductUpdatesModal
              userCurriculumPrograms={userCurriculumPrograms}
            />
          )
        ) : null}
        {showBifurcationModal && <Bifurcation firstName={firstName} />}
        {/**ClassSelectionModal is shown only for free PYP Curriculum program */}
        {showClassSelectionScreen && isPYPFree && (
          <UIModal
            isFullScreen={true}
            isOpen={true}
            overlayContainer={classes.overlayContainer}
          >
            <ClassSelectionModal
              onClickDoneCourses={this.classSelectionDoneListener}
            />
          </UIModal>
        )}
        {!_.isEmpty(calendarEventModal) && (
          <UIModal
            isOpen={true}
            modalContent={classes.modalContentCalendarEvent}
            overlayContainer={classes.modalOverlayCalendarEvent}
            onRequestClose={this.onCloseCalendarEventModal}
          >
            <EventModal
              eventId={_.get(calendarEventModal, "id", null)}
              onCloseEventModal={this.onCloseCalendarEventModal}
              accessedViaDailyView={true}
            />
          </UIModal>
        )}
        {!_.isEmpty(calendarEventDetails) && (
          <UIModal
            isOpen={true}
            modalContent={classes.modalContentCalendarEvent}
            overlayContainer={classes.modalOverlayCalendarEvent}
            onRequestClose={this.onCloseCalendarEventDetails}
          >
            <EventDetails
              eventId={_.get(calendarEventDetails, "id", null)}
              onCloseClick={this.onCloseCalendarEventDetails}
            />
          </UIModal>
        )}
        {/** Modal for AI product marketing **/}

        {isMarketingModalEnabled() ? <AIModuleMarketingModal /> : null}

        <ShortcutToast />
        {userType === "staff" ? <ShortcutManager /> : null}
        {!isSentralStudentProfile ? <SentralPortalModalCloseToast /> : null}
        <SentralPortalModal
          shouldShowBelowHeader={userType === "student" ? true : false}
        />
        <SamlIdpResponseScreen samlInitiatedDetails={samlInitiatedDetails} />
      </KeyboardShortcutsProvider>
    );
  }
}

ChildrenPage.displayName = "ChildrenPage";

const mapActionCreators = {
  setUserInfo,
  updateBasicUserDetails,
  updateUserCourses,
  setBifurcationModalStatus,
  updateNavigationObject,
  setIsLastChildRemoved,
  goToRelativeRoute,
  addFeaturesWithKeyboardShortcuts,
  removeFeaturesWithKeyboardShortcuts,
  setActiveFeatureWithKeyboardShortcuts,
  setIsAIUsageLimitModalOpen,
  setGlobalTrayRetracted,
  setSelectedGlobalTrayIcon,
  handleGlobalKeyboardEvents,
  logUserActivity,
  setSentralPortalDetails,
  setToastMsg,
  openLinkInNewTab,
};

const getConfigurationEnhancerCb = ({
  ownProps,
  configurationResponse,
} = {}) => {
  const { isData, isLoading, skipPreloadConfigrations } = ownProps;

  const newConfigList = _.get(configurationResponse, "0.configurations", []);
  ACLStore.updateConfig("ORGANIZATION", newConfigList);
  const hasData = !_.isEmpty(newConfigList);

  return {
    isData: skipPreloadConfigrations ? isData && hasData : isData,
    ...(!skipPreloadConfigrations ? isLoading : {}),
  };
};

const getPreloadConfigurationEnhancerCb = ({
  ownProps,
  configurationResponse,
} = {}) => {
  const { isData } = ownProps;

  const newConfigList = _.get(configurationResponse, "0.configurations", []);
  ACLStore.updateConfig("ORGANIZATION", newConfigList);
  const hasData = !_.isEmpty(newConfigList);

  return { isData: isData && hasData };
};

const mapStateToProps = (state, ownProps) => {
  const portalType = "PLANNER";
  const userInfo = getUserInfo({ portalType });
  const childID =
    _.get(state, "login.userInfo.childID", "") ||
    _.get(state, "login.childID", "");

  const user_type = userInfo.user_type;
  const productUpdateModalId = _.get(state, "login.productUpdateModalId");
  const bifurcationModalStatus = _.get(state, "login.bifurcationModalStatus");

  const permissionGroups = state.teacher.permissionGroups[user_type];

  const activeCurriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    CURRICULUM_TYPE_PYP
  );

  const isResourceUnavailable = _.get(
    state,
    "app_services.isResourceUnavailable",
    false
  );

  const selectedAcademicYearId = getSelectedAcademicYearId(state);

  const isCurriculumProgramFree = getCurriculumProgramFreeStatus({ state });
  const isPYPFree =
    isCurriculumProgramFree &&
    activeCurriculumProgramType == CURRICULUM_TYPE_PYP;

  const currentCurriculumProgramPlan = _.get(
    state,
    "platform.currentCurriculumProgram.subscriptionPlan.type",
    ""
  );

  const currentLanguage = _.get(ownProps, "i18n.language", "");

  const isChildBlocked = _.get(state, "login.userInfo.isChildBlocked", true);
  const childBlockedMessage = _.get(
    state,
    "login.userInfo.childBlockedMessage",
    ""
  );

  const pageTitleInfo = _.get(state, "login.currentPageTitle");
  const courseId = _.get(state, "teacher.selected_class.selected_course", "");
  const curriculumTypeName = _.get(
    state,
    "platform.currentCurriculumProgram.acronym",
    ""
  );

  const isSampleOrg = _.get(state, "platform.sampleOrgPortalType", null);

  const featuresWithKeyboardShortcuts = _.get(
    state,
    "app_services.featuresWithKeyboardShortcuts",
    EMPTY_ARRAY
  );

  const learningCourseDetails = getSelectedLearningCourse(state);
  const isSentralModalVisible = _.get(
    state,
    "login.sentralPortalDetails.isVisible",
    false
  );
  const samlInitiatedDetails = _.get(state, "login.samlInitiatedDetails", {});

  return {
    isCurriculumProgramFree,
    isChildBlocked,
    childBlockedMessage,
    activeTab: state.login.activeTab,
    permissionGroups,
    selectedAcademicYear: _.get(state, "platform.academicYearSelected"),
    bifurcationModalStatus,
    calendarEventModal: state.navigation.navigationObject.calendarEventModal,
    calendarEventDetails: _.get(
      state,
      "navigation.navigationObject.calendarEventDetails",
      {}
    ),
    childID,
    productUpdateModalId,
    isLastChildRemoved: _.get(state, "login.isLastChildRemoved", false),
    isPYPFree,
    pageTitleInfo,
    courseId,
    curriculumTypeName,
    academicYearId: selectedAcademicYearId,
    reduxAcademicYearId: selectedAcademicYearId,
    currentCurriculumProgramPlan,
    currentLanguage,
    isSampleOrg,
    featuresWithKeyboardShortcuts,
    isGlobalTrayEnabled: _.get(state, "login.isGlobalTrayEnabled"),
    isGlobalTrayRetracted: _.get(state, "login.isGlobalTrayRetracted"),
    totalUnreadTrayCount: _.get(state, "login.totalUnreadTrayCount"),
    showSearchBar: _.get(
      state,
      "app_services.globalSearchBar.showSearchBar",
      false
    ),
    isJumpToFeatureOpen:
      _.get(state, "app_services.activeFeatureWithKeyboardShortcuts") ===
      "JUMP_TO_FEATURE",
    isInternalToolModalOpen: _.get(state, "internal_tools.isOpen", false),
    showAIUsageLimitModal: _.get(
      state,
      "app_services.showAIUsageLimitModal",
      false
    ),
    learningCourseDetails,
    isSentralModalVisible,
    isResourceUnavailable,
    samlInitiatedDetails,
  };
};

const getDerivedProps = ownProps => {
  const { userLoggedIn, childID } = ownProps;

  const portalType = "PLANNER";
  const userInfo = getUserInfo({ portalType });

  const userId = userInfo.id;
  const user_type = userInfo.user_type;

  const routeCourseId = _.get(ownProps, "params.course_id");

  const orgWorkspaceDetails = getOrgWorkSpaceDetails();
  const workspaceId = _.get(orgWorkspaceDetails, "organizationId"); // school scoped login orgId

  const organizationId = userInfo.org_id;

  const skipUserCurriculumQuery =
    !organizationId ||
    !userLoggedIn ||
    (user_type === "parent" && !childID) ||
    user_type === "staff";

  const skipPreloadConfigrations = skipPreloadConfigurationsQuery();

  const skipConfigurationQuery =
    !userId ||
    !userLoggedIn ||
    !organizationId ||
    (skipPreloadConfigrations && user_type !== "parent");

  const configurationQueryVariables = generateConfigurationQueryVariablesMemoized(
    {
      src: "ORGANIZATION_LEVEL",
      organizationId: organizationId,
    }
  );

  const skipPreloadConfigurationQuery =
    skipConfigurationQuery ||
    user_type !== "parent" ||
    skipPreloadConfigrations;

  const preloadConfigurationQueryVariables = generateConfigurationQueryVariablesMemoized(
    {
      src: "ORGANIZATION_LEVEL",
      fetchInitialLoadConfigurations: true,
      organizationId,
    }
  );

  const isUserTypeStaff = getIsStaff();

  const userDetails = getUserBasicDetailsFromCache({
    id: userInfo.id,
    type: userInfo.userEntityType,
  });

  const showClassSelectionScreen = _.get(
    userDetails,
    "showClassSelectionScreen",
    false
  );

  return {
    routeCourseId,
    workspaceId,
    skipUserCurriculumQuery,
    skipPreloadConfigrations,
    useHttpLink: !skipPreloadConfigrations,
    skipConfigurationQuery,
    configurationQueryVariables,
    preloadConfigurationQueryVariables,
    skipPreloadConfigurationQuery,
    isUserTypeStaff,
    skipUserAllStaffPermissionConfig: true,
    showClassSelectionScreen,
    isPrivate: false,
    portalType,
    userEntityType: _.get(
      USER_TYPE_ENTITY_MAPPING[user_type],
      "entityType",
      ""
    ),
    user_type,
    studentId: _.isEqual(user_type, "parent") ? childID : userId,
    parentToken: _.get(userInfo, "parentToken", ""),
    userId,
    isData: true,
    isLoading: false,
    childID,
    organizationIdFallback: organizationId,
  };
};

const getFeatureFlagBasedProps = ownProps => {
  const { user_type, userId, organizationId } = ownProps;

  const {
    areShortcutsEnabled,
    areShortcutPromptsEnabled,
  } = getShortcutPreferenceValues({ userId, organizationId });

  return {
    isIntercomV2Enabled: ACLStore.can("FeatureFlag:IntercomV2"),
    showSprinklrChat: getShowSprinklrChat({ userType: user_type }),
    areShortcutsEnabled,
    areShortcutPromptsEnabled,
  };
};

const getUserCurriculumProgramBasedProps = ownProps => {
  const {
    userId,
    userLoggedIn,
    user_type,
    isLoading,
    academicYearId,
    selectedAcademicYear,
    organizationCurriculumPrograms,
    organizationId,
  } = ownProps;

  let userCurriculumPrograms;

  if (user_type === "staff") {
    const { staffAcademicYearCurriculumMap = [] } = ownProps;

    ({ userCurriculumPrograms } =
      (!_.isEmpty(staffAcademicYearCurriculumMap) &&
        academicYearId &&
        getStaffUserDetailsMemoize({
          staffAcademicYearCurriculumMap,
          academicYearId,
          organizationCurriculumPrograms,
        })) ||
      {});
  } else {
    const {
      organizationAcademicYears,
      academicYearCurriculumProgramsMapping,
      userCurriculumProgramsForAcademicYear = [],
    } = ownProps;

    const organizationAcademicYearsIds = _.map(organizationAcademicYears, "id");

    const organizationCurriculumProgramsIdAndLabels = _.map(
      organizationCurriculumPrograms,
      curriculumProgram => ({
        id: curriculumProgram.id,
        label: curriculumProgram.label,
      })
    );

    const userCurriculumProgramsForAcademicYearIdAndLabels = _.map(
      userCurriculumProgramsForAcademicYear,
      curriculumProgram => ({
        id: curriculumProgram.id,
        label: curriculumProgram.label,
      })
    );

    const canListAndAccessAllPrograms = ACLStorage.getModuleSettingsValue(
      LIST_AND_ACCESS_ALL_PROGRAMMES_HOMEPAGE_PERMISSION
    );

    ({ userCurriculumPrograms } =
      (!_.isEmpty(organizationAcademicYears) &&
        academicYearCurriculumProgramsMapping &&
        selectedAcademicYear &&
        getNonStaffUserDetailsMemoize({
          userId,
          organizationAcademicYears,
          academicYearCurriculumProgramsMapping,
          selectedAcademicYear,
          organizationCurriculumPrograms,
          organizationAcademicYearsIds,
          organizationCurriculumProgramsIdAndLabels,
          userCurriculumProgramsForAcademicYear,
          userCurriculumProgramsForAcademicYearIdAndLabels,
          canListAndAccessAllPrograms,
          organizationId,
        })) ||
      {});
  }

  const skipUserAllStaffPermissionConfig =
    !userId ||
    !userLoggedIn ||
    user_type !== "staff" ||
    _.isEmpty(userCurriculumPrograms) ||
    isLoading;

  const userAllStaffPermissionConfig =
    !_.isEmpty(userCurriculumPrograms) &&
    generateConfigurationQueryVariablesMemoized({
      src: "TEACHER_PERMISSION",
      curriculumProgramList: userCurriculumPrograms,
    });

  return {
    userAllStaffPermissionConfig,
    skipUserAllStaffPermissionConfig,
  };
};

const manageUserData = ({ childData, userData, parentToken }) => {
  const {
    firstName = "",
    middleName = "",
    lastName = "",
    preferredName = "",
    suffix = "",
    prefix = "",
    pronouns = "",
  } = childData || {};

  userData.parentToken = parentToken;
  userData.email = _.get(userData, "Email", "");
  userData.jwt = _.get(childData, "jwt", "");
  userData.childID = _.get(childData, "id", "");
  userData.childProfileImage = _.get(childData, "profileImage", "");
  userData.childFirstName = firstName;
  userData.childMiddleName = middleName;
  userData.childLastName = lastName;
  userData.childPronouns = pronouns;
  userData.childPreferredName = preferredName;
  userData.childPrefix = prefix;
  userData.childSuffix = suffix;
  userData.childName = `${firstName} ${lastName}`;
  userData.childFormattedName = getFormattedUserName({ user: childData });
  userData.childIdentifierName = getUserIdentifierName({ user: childData });
  userData.isChildBlocked = _.get(childData, "isBlocked", true);
  userData.childBlockedMessage = _.get(childData, "blockMessage", "");
};

const getPlatformUserData = ({
  staffDataFromCache,
  childID,
  parentToken,
  workspaceId,
}) => {
  const userData = { ...(staffDataFromCache || {}) };

  const userType = _.get(userData, "type", "");

  let organizationData, organizationId, allCourses;

  if (userType === "parent") {
    const children = _.get(userData, "children", []);

    // childID is from local storage
    const activeChildData = _.find(children, { id: childID });

    // if no active child data then, find child having orgId equal to workspace login orgId or get first element of array
    const childData = !_.isEmpty(activeChildData)
      ? activeChildData
      : !_.isEmpty(workspaceId)
      ? _.find(children, { organization: { id: workspaceId } })
      : _.head(children);

    // "userData" is passed by reference
    manageUserData({
      childData,
      userData,
      parentToken,
    });

    allCourses = _.get(childData, "allCourses", []);
    organizationData = _.get(childData, "organization", {});
    organizationId = _.get(organizationData, `id`, "");
  } else {
    allCourses = _.get(userData, "allCourses", []);
    organizationData = _.get(userData, "organization", {});
    organizationId = _.get(organizationData, `id`, "");
  }

  if (userType === "staff") {
    userData.identityId = _.get(userData, "linkedIdentityV2.id", null);
  }

  const orgAcademicYears = _.get(organizationData, "academicYears", []);
  const organizationCurriculumPrograms = _.get(
    organizationData,
    "curriculumPrograms",
    []
  );
  const { academicYearCurriculumProgramsMapping } =
    userType !== "staff"
      ? getUserAcadYearConstantsMemoize({
          allCourses,
          orgAcademicYears,
          organizationCurriculumPrograms,
        })
      : {};

  return {
    staffData: userData,
    organizationData,
    organizationId,
    academicYearCurriculumProgramsMapping,
    organizationCurriculumPrograms,
  };
};

const withCurriculumProgramsInjector = WrappedComponent => {
  const CurriculumProgramsInjector = props => {
    const {
      organizationCurriculumPrograms,
      userId,
      academicYearId,
      selectedAcademicYear,
      organizationId,
      user_type,
    } = props;

    let userCurriculumPrograms;

    if (user_type === "staff") {
      const { staffAcademicYearCurriculumMap = [] } = props;

      ({ userCurriculumPrograms } = getStaffUserDetailsMemoize({
        staffAcademicYearCurriculumMap,
        academicYearId,
        organizationCurriculumPrograms,
      }));
    } else {
      const {
        organizationAcademicYears,
        academicYearCurriculumProgramsMapping,
        userCurriculumProgramsForAcademicYear = [],
      } = props;

      const organizationAcademicYearsIds = _.map(
        organizationAcademicYears,
        "id"
      );

      const organizationCurriculumProgramsIdAndLabels = _.map(
        organizationCurriculumPrograms,
        curriculumProgram => ({
          id: curriculumProgram.id,
          label: curriculumProgram.label,
        })
      );

      const userCurriculumProgramsForAcademicYearIdAndLabels = _.map(
        userCurriculumProgramsForAcademicYear,
        curriculumProgram => ({
          id: curriculumProgram.id,
          label: curriculumProgram.label,
        })
      );

      const canListAndAccessAllPrograms = ACLStorage.getModuleSettingsValue(
        LIST_AND_ACCESS_ALL_PROGRAMMES_HOMEPAGE_PERMISSION
      );

      ({ userCurriculumPrograms } = getNonStaffUserDetailsMemoize({
        userId,
        organizationAcademicYears,
        academicYearCurriculumProgramsMapping,
        selectedAcademicYear,
        organizationCurriculumPrograms,
        organizationAcademicYearsIds,
        organizationCurriculumProgramsIdAndLabels,
        userCurriculumProgramsForAcademicYear,
        userCurriculumProgramsForAcademicYearIdAndLabels,
        canListAndAccessAllPrograms,
        organizationId,
      }));
    }

    return (
      <WrappedComponent
        {...props}
        userCurriculumPrograms={userCurriculumPrograms}
      />
    );
  };
  return CurriculumProgramsInjector;
};

export default compose(
  // --- HOCs ---
  I18nHOC({ resource: ["common", "blockScreen", "toastMsgs"] }),
  connect(mapStateToProps, mapActionCreators),
  withDerivedProps(getDerivedProps),

  // --- 1st waterfall: independent (fire immediately) ---
  graphql(getPlatformStaffIdentityDetailsQuery, {
    name: "getPlatformStaffIdentityDetails",
    skip: ({ userLoggedIn, user_type }) =>
      !userLoggedIn || user_type !== "staff",
    options: ({ userId, userEntityType, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: userId,
        type: userEntityType,
        portalType,
      },
    }),
    props({ getPlatformStaffIdentityDetails }) {
      const variables = _.get(getPlatformStaffIdentityDetails, "variables", {});
      const staffIdentityDetails = getPlatformStaffIdentityDetailsFromCache(
        variables
      );

      return {
        staffIdentityDetails,
      };
    },
  }),
  graphql(getStaffAcademicYearCurriculumMapQuery, {
    name: "getStaffAcademicYearCurriculumMap",
    skip: ({ userLoggedIn, isUserTypeStaff }) =>
      !userLoggedIn || !isUserTypeStaff,
    options: ({ userId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids: [userId],
        filters: {
          includeBehaviourPrograms: true,
          includeRnPAccessPrograms: true,
        },
      },
    }),
    props: ({
      getStaffAcademicYearCurriculumMap,
      ownProps: { isData, isLoading },
    }) => {
      const academicYearCurriculumMapRaw = _.get(
        getStaffAcademicYearCurriculumMap,
        "platform.staff[0].academicYearCurriculumMap",
        []
      );

      // Filter out ACCOUNT programType — only keep SCHOOL programs
      const staffAcademicYearCurriculumMap = _.map(
        academicYearCurriculumMapRaw,
        entry => ({
          ...entry,
          curriculumPrograms: _.filter(
            entry.curriculumPrograms,
            ({ programType }) => programType !== "ACCOUNT"
          ),
        })
      );

      return {
        staffAcademicYearCurriculumMap,
        isData: !_.isEmpty(academicYearCurriculumMapRaw) && isData,
        isLoading:
          getStaffAcademicYearCurriculumMap["networkStatus"] == 1 ||
          getStaffAcademicYearCurriculumMap["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getPlatformUserDetailsQuery, {
    name: "getPlatformUserDetails",
    skip: ({ userLoggedIn }) => !userLoggedIn,
    options: ({ userId, portalType, userEntityType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: userId,
        type: userEntityType,
        portalType,
      },
    }),
    props({
      getPlatformUserDetails,
      ownProps: {
        userId,
        isData,
        isLoading,
        userEntityType,
        childID,
        parentToken,
        isLastChildRemoved,
        workspaceId,
        organizationIdFallback,
      },
    }) {
      const staffDataFromCache = _.get(getPlatformUserDetails, "node", {});

      const {
        academicYearCurriculumProgramsMapping,
        organizationData,
        organizationId = organizationIdFallback,
        staffData,
        organizationCurriculumPrograms,
      } =
        (!_.isEmpty(staffDataFromCache) &&
          getPlatformUserData({
            staffDataFromCache,
            childID,
            parentToken,
            userId,
            userEntityType,
            workspaceId,
          })) ||
        {};

      // default
      let isPlatformData = !_.isEmpty(staffData) && isData;

      /** __Family Portal__
       * 1. "isLastChildRemoved" will be true when last remaining child is removed from settings page in Family Portal (Refer: ParentSettings.js)
       * 2. Without this condition, cached staffData was getting set in Local Storage which didn't included jwt
       *    .... without jwt the succeding network request was failing and throwing "Un-authenticated error"
       * 3. As a result, Don't return data unless jwt is arrived from network request
       */
      if (isLastChildRemoved) {
        isPlatformData =
          !_.isEmpty(staffData) &&
          isData &&
          !_.isEmpty(_.get(staffData, "jwt", ""));
      }

      return {
        getPlatformUserDetails,
        organizationId,
        academicYearCurriculumProgramsMapping,
        organizationData,
        staffData,
        isData: isPlatformData,
        organizationCurriculumPrograms,
        isLoading:
          getPlatformUserDetails["networkStatus"] == 1 ||
          getPlatformUserDetails["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getCourseAcademicYearsQuery, {
    name: "getCourseAcademicYears",
    skip: ({ courseId, reduxAcademicYearId, isUserTypeStaff }) =>
      !isUserTypeStaff || !courseId || !!reduxAcademicYearId,
    options: ({ courseId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: courseId,
      },
    }),
    props: ({ getCourseAcademicYears, ownProps: { isData, isLoading } }) => {
      const courseAcademicYears = _.get(
        getCourseAcademicYears,
        "node.academicYears",
        []
      );

      return {
        courseAcademicYears,
        isData: !_.isEmpty(_.get(getCourseAcademicYears, "node")) && isData,
        isLoading:
          getCourseAcademicYears["networkStatus"] == 1 ||
          getCourseAcademicYears["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getGlobalConstantsQuery, {
    name: "getGlobalConstants",
    skip: ({ userLoggedIn, isChildBlocked, user_type }) =>
      !userLoggedIn || (user_type !== "staff" && isChildBlocked),
    options: ({ portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        portalType,
      },
    }),
    props({ getGlobalConstants, ownProps: { isData, isLoading } }) {
      return {
        isData: _.get(getGlobalConstants, "globalConstants", {}) && isData,
        isLoading:
          getGlobalConstants["networkStatus"] == 1 ||
          getGlobalConstants["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getOrganizationDetailsQuery, {
    name: "getOrganizationDetails",
    skip: ({
      organizationId,
      userLoggedIn,
      user_type,
      childID,
      isChildBlocked,
    }) =>
      !organizationId ||
      !userLoggedIn ||
      (user_type === "parent" && !childID) ||
      (user_type !== "staff" && isChildBlocked),
    options: ({ organizationId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: organizationId,
        portalType: "PLANNER",
      },
    }),
    props: ({
      getOrganizationDetails,
      ownProps: { isData, isLoading, organizationId, academicYearId, location },
    }) => {
      const organizationDetails = _.get(getOrganizationDetails, "node", {});

      const currentAcademicYear = getCurrentAcademicYear({ organizationId });
      let newAcademicYearId = academicYearId;

      // If we have URL with queryBody with academicYearId, then change academic year selected
      const { academicYearId: academicYearIdFromURL } = _.get(
        location,
        `query`,
        {}
      );
      if (academicYearIdFromURL) {
        const academicYears = _.get(organizationDetails, "academicYears", []);
        const queryAcademicYear = _.find(academicYears, {
          id: academicYearIdFromURL,
        });
        if (!_.isEqual(academicYearId, academicYearIdFromURL)) {
          newAcademicYearId = _.get(queryAcademicYear, "id", null);
        }
      } else if (!academicYearId && !_.isEmpty(currentAcademicYear)) {
        newAcademicYearId = _.get(currentAcademicYear, "id", null);
      }

      const personalProject = _.get(
        organizationDetails,
        "personalProject",
        null
      );

      const communityProject = _.get(
        organizationDetails,
        "communityProject",
        null
      );

      const serviceAsAction = _.get(
        organizationDetails,
        "serviceAsAction",
        null
      );

      const projects = {
        personalProject,
        communityProject,
        serviceAsAction,
      };

      const organizationAcademicYears = _.get(
        organizationDetails,
        "academicYears",
        []
      );

      const isFetching =
        _.includes([1, 2, 4], getOrganizationDetails["networkStatus"]) ||
        isLoading;

      return {
        getOrganizationDetails,
        isData: !_.isEmpty(organizationDetails) && isData,
        projects,
        organizationAcademicYears,
        isLoading: isFetching,
        academicYearId: newAcademicYearId,
      };
    },
  }),
  graphql(getOrganizationGlobalConstantsQuery, {
    name: "getOrganizationGlobalConstants",
    skip: ({ organizationId }) => !organizationId,
    options: ({ organizationId, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        organizationId,
        filter: {
          names: ["TIMEZONE"],
        },
        portalType,
      },
    }),
    props({ getOrganizationGlobalConstants, ownProps: { isData, isLoading } }) {
      const data = _.get(getOrganizationGlobalConstants, "node", {});
      return {
        isData: !_.isEmpty(data) && isData,
        isLoading:
          getOrganizationGlobalConstants["networkStatus"] == 1 ||
          getOrganizationGlobalConstants["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getOrganizationConstantsQuery, {
    name: "getOrganizationConstants",
    skip: ({ organizationId }) => !organizationId,
    options: ({ organizationId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: organizationId,
      },
      context: {
        useHttpLink: true,
      },
    }),
  }),
  getConfigurationQueryEnhancer(getPreloadConfigurationEnhancerCb, {
    skipConfigurationQueryKey: "skipPreloadConfigurationQuery",
    configurationQueryVariablesKey: "preloadConfigurationQueryVariables",
  }),
  WithConfigurationsAndPreferences({
    skip: ({ user_type, organizationId }) =>
      user_type === "parent" || !organizationId,
    options: ({ organizationId }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: generateConfigurationQueryVariablesV2({
          src: "ORGANIZATION_LEVEL",
          organizationId,
          modules: ["PLATFORM_HOMEPAGE"],
        }),
      };
    },
    configurations: {
      getConfigurationKey: () => "ORGANIZATION",
    },
  }),
  getConfigurationQueryEnhancer(getConfigurationEnhancerCb, {
    useHttpLink: "useHttpLink",
  }),
  getPreferenceQueryEnhancer(null, {
    useHttpLink: "useHttpLink",
  }),

  // --- 2nd waterfall: depends on 1st waterfall results ---
  graphql(getOrganizationGlobalConstantsQuery, {
    name: "getBehaviourNomenclatureConstants",
    skip: ({ organizationId }) => {
      const isBehaviourModuleEnabled = ACLStore.can([
        ENABLE_BEHAVIOUR_MODULE_PERM,
        ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
      ]);
      return !isBehaviourModuleEnabled || !organizationId;
    },
    options: ({ organizationId }) => ({
      fetchPolicy: "cache-and-network",
      variables: getBehaviourNomenclatureFiltersMemoized({ organizationId }),
      context: {
        useHttpLink: true,
      },
    }),
  }),
  withControlParameters({
    skip: ({ user_type }) => user_type !== "staff",
    options: () => {
      return {
        variables: {
          filters: {
            module: "SCHOOL_WIDE_CONFIGURATIONS",
            appType: ["ADMIN_WEB", "TEACHER_WEB"],
          },
        },
      };
    },
  }),
  graphql(getUserProjectGroupsQuery, {
    name: "getUserProjectGroups",
    skip: ({
      childID,
      user_type,
      academicYearId,
      isSampleOrg,
      isChildBlocked,
    }) =>
      (user_type === "parent" && !childID) ||
      isSampleOrg ||
      !academicYearId ||
      (user_type !== "staff" && isChildBlocked),
    options: ({
      userId,
      userEntityType,
      user_type,
      childID,
      academicYearId,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: user_type === "parent" ? childID : userId,
        type: userEntityType === "FAMILY_MEMBER" ? "STUDENT" : userEntityType,
        filters: {
          yearGroupArchivalState: "ALL",
          academicYears: [academicYearId],
        },
        portalType: "PLANNER",
      },
      context: {
        useHttpLink: true, // have to check this to know why it is done
      },
    }),
    props({ getUserProjectGroups, ownProps: { isData, isLoading } }) {
      const variables = _.get(getUserProjectGroups, "variables", {});

      const data = getUserProjectGroupsFromCache(variables);

      const isFetching =
        _.includes([1, 2], getUserProjectGroups["networkStatus"]) || isLoading;

      return {
        isData: !_.isEmpty(data) && isData,
        isLoading: isFetching,
        onPusherEventTriggered: getUserProjectGroups.refetch,
        projectGroups: _.get(data, "node.projectGroups", []),
        isUserProjectGroupsQueryCompleted: !_.isEmpty(data),
      };
    },
  }),
  graphql(getStudentsCurriculumQuery, {
    name: "getStudentsCurriculum",
    skip: ({ skipUserCurriculumQuery, isChildBlocked }) =>
      skipUserCurriculumQuery || isChildBlocked,
    options: ({ studentId, academicYearId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids: [studentId],
        studentCurriculumProgramFilters: { academicYearId },
      },
    }),
    props: ({
      getStudentsCurriculum,
      ownProps: { isData, studentId, academicYearId },
    }) => {
      const data = getStudentsCurriculumFromCache(studentId, {
        academicYearId,
      });

      const userCurriculumProgramsForAcademicYear = _.get(
        data,
        "curriculumPrograms"
      );

      return {
        userCurriculumProgramsForAcademicYear,
        getStudentsCurriculum,
        isData: !_.isEmpty(data) && isData,
      };
    },
  }),
  withDerivedProps(getFeatureFlagBasedProps),
  withDerivedProps(getUserCurriculumProgramBasedProps),

  // --- 3rd waterfall: needs userCurriculumPrograms from curriculum queries ---
  getConfigurationQueryEnhancer(null, {
    skipConfigurationQueryKey: "skipUserAllStaffPermissionConfig",
    configurationQueryVariablesKey: "userAllStaffPermissionConfig",
    fetchPolicy: "cache-and-network",
    useHttpLink: true,
  }),
  getPreferenceQueryEnhancer(null, {
    skipConfigurationQueryKey: "skipUserAllStaffPermissionConfig",
    configurationQueryVariablesKey: "userAllStaffPermissionConfig",
    fetchPolicy: "cache-and-network",
    useHttpLink: true,
  }),

  // --- Final HOCs ---
  withPrivateScreen(),
  withPusherBind(["userProjectUpdated"]),
  withCurriculumProgramsInjector, // IMPORTANT: this will create list of curriculumPrograms for current user, must be called after all required data used to prepare currculumPrograms list are available by queries
  withLoader
)(ChildrenPage);
